import React from "react"
import { Link } from 'gatsby';

import styled from 'styled-components';
import ArrowRight from '../../../icons/ArrowRight'

interface IProps {
  link?: string
  label?: string,
  exact?: boolean,
  currentRoute: Location
}
const SubMenuItem: React.FC<IProps> = (props) => {
  const { label, link = '', exact, currentRoute: { pathname } } = props
  const isActive = exact ? pathname === link : pathname.includes(link)
  return (
    <MenuList className={isActive ? "active" : ''}>
      {link && <Link to={link}>
        <ArrowRight />
        <span>{label}</span>
      </Link>}
    </MenuList>
  )
}

const MenuList = styled.li`
  border-top: #b7b1a4 dashed 1px;
  border-bottom: #b7b1a4 dashed 1px;
  padding: 6px;
  text-align: left;
  font-weight: 700;
  font-size: 0.9em;
  margin-bottom: 2px;
  color: #005daa;
  & :hover {
    color: #ffffff;
    background: #005daa;
    a {
      color: #ffffff;
      svg g path{
        fill: #fff
      }
    }
  }
  & a {
    color: #005daa;
    text-decoration: none;
    display: flex;
    align-items: center;
    svg {
      width: 20px;
      height: 20px;
      position: absolute;
      left: -1px;
    }
    span{
      margin-left: 13px
    }
  }
  &.active {
    color: #ffffff;
    background: #bfcde3;
    & a {
      color: #ffffff;
    }
  }
`

export default SubMenuItem
